import React from "react";
import Menu from "../components/sections/Menu";
const MenuPage = () => {
  return (
      <div className="pt-24">
        <Menu />
      </div> 
  );
};

export default MenuPage;
